export const PRIORITIES = ["LOW", "MEDIUM", "HIGH", "URGENT"];

export const PRIORITY_META = {
  LOW: { label: "Low", color: "#64748b", bg: "#f1f5f9" },
  MEDIUM: { label: "Medium", color: "#2563eb", bg: "#dbeafe" },
  HIGH: { label: "High", color: "#ea580c", bg: "#ffedd5" },
  URGENT: { label: "Urgent", color: "#dc2626", bg: "#fee2e2" },
};

export const STATUS_META = {
  OPEN: { label: "Open", color: "default" },
  IN_PROGRESS: { label: "In Progress", color: "processing" },
  REVIEW: { label: "Review", color: "warning" },
  DONE: { label: "Done", color: "success" },
  CANCELLED: { label: "Cancelled", color: "default" },
};

export const PROJECT_COLORS = [
  "#6366f1",
  "#8b5cf6",
  "#ec4899",
  "#f43f5e",
  "#f97316",
  "#eab308",
  "#22c55e",
  "#14b8a6",
  "#0ea5e9",
  "#64748b",
];

export function userDisplayName(user) {
  if (!user) return "Unknown";
  return user.display_name || [user.first_name, user.last_name].filter(Boolean).join(" ") || user.email || "User";
}

export function userInitials(user) {
  const name = userDisplayName(user);
  const parts = name.split(" ").filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name.slice(0, 2).toUpperCase();
}

export function isOverdue(dueDate, status) {
  if (!dueDate || ["DONE", "CANCELLED"].includes(status)) return false;
  return dueDate < new Date().toISOString().slice(0, 10);
}

export function formatFileSize(bytes) {
  if (!bytes) return "0 B";
  const units = ["B", "KB", "MB", "GB"];
  let i = 0;
  let size = bytes;
  while (size >= 1024 && i < units.length - 1) {
    size /= 1024;
    i += 1;
  }
  return `${size.toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
}

/** Normalize Mongo id values from API/state to plain strings for requests. */
export function normalizeId(value) {
  if (value == null) return "";
  if (typeof value === "string") return value;
  if (typeof value === "object" && value._id != null) return normalizeId(value._id);
  return String(value);
}
